import React from "react";
import {
  CheckCircle,
  Building2,
  ShieldCheck,
  FileCheck,
  Handshake,
} from "lucide-react";
import jaina from "../Images/jaina.png";
import scrap5 from "../Images/scrap5.png";
import Scrap3 from "../Images/Scrap3.png";
import { useNavigate } from "react-router-dom";


const AboutUsSection = () => {
  const navigate=useNavigate();
  return (
    <section className="about-section">

      {/* HEADING */}
      <div className="section-heading">
        <h1>ABOUT US</h1>
      </div>

      <div className="container">

        {/* LEFT IMAGES */}
        <div className="left">
          <img src={jaina} alt="Scrap Metal" className="img img3" />
          <img src={scrap5} alt="scrap metal" className="img img1" />
          <img src={Scrap3} alt="scrap metal" className="img img2" />
        </div>

        {/* RIGHT CARD */}
        <div className="about-box">

          <div className="company-title">
            <Building2 size={32} />
            <h2>Jaina Enterprises</h2>
          </div>

          <p>
            Jaina Enterprises is a trusted and respected name in the metal supply industry.
            We are committed to conducting clean, transparent, and GST-compliant business transactions.
          </p>

          <div className="features">
            <div className="feature"><CheckCircle size={18} /><span>100% Industrial Supply Network</span></div>
            <div className="feature"><Building2 size={18} /><span>Verified Warehouse Address</span></div>
            <div className="feature"><FileCheck size={18} /><span>Complete GST Compliance</span></div>
            <div className="feature"><ShieldCheck size={18} /><span>Timely Tax Payments</span></div>
            <div className="feature"><Handshake size={18} /><span>Ethical Business Practices</span></div>
          </div>

          <p className="note">
            We maintain highest standards of professionalism and integrity.
          </p>

          <button className="about-btn" onClick={()=>navigate('/about')}>More Details</button>
        </div>

      </div>

    <style>{`
.about-section{
  width:100%;
  padding:70px 20px;
  background:linear-gradient(135deg,#f8fafc,#eef4ff);
  overflow:hidden;
}

/* =========================
   HEADING
========================= */

.section-heading{
  text-align:center;
  margin-bottom:60px;
  position:relative;
}

.section-heading h1{
  font-size:48px;
  font-weight:800;
  color:#0A2E73;
  letter-spacing:4px;
  text-transform:uppercase;
  margin:0;
  display:inline-block;
  position:relative;
}

.section-heading h1::after{
  content:"";
  width:90px;
  height:4px;
  background:#d4af37;
  position:absolute;
  left:50%;
  bottom:-12px;
  transform:translateX(-50%);
  border-radius:50px;
  transition:.4s;
}

.section-heading h1:hover::after{
  width:150px;
  background:linear-gradient(90deg,#d4af37,#f2cf63,#d4af37);
  box-shadow:0 6px 15px rgba(212,175,55,.4);
}

/* =========================
   LAYOUT
========================= */

.container{
  max-width:1200px;
  margin:auto;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:50px;
}

/* =========================
   LEFT IMAGE SECTION
========================= */

.left{
  flex:1;
  position:relative;
  min-height:520px;
}

.img{
  position:absolute;
  border-radius:20px;
  object-fit:cover;
  border:5px solid #fff;
  box-shadow:0 15px 35px rgba(0,0,0,.15);
  transition:.4s;
}

.img:hover{
  transform:translateY(-8px) scale(1.03);
}

.img1{
  width:50%;
  height:230px;
  top:0;
  right:0;
}

.img2{
  width:60%;
  height:200px;
  bottom:0;
  right:10px;
}

.img3{
  width:70%;
  height:320px;
  top:40px;
  left:0;
}

/* =========================
   RIGHT CONTENT
========================= */

.about-box{
  flex:1;
  background:#0A2E73;
  color:#fff;
  padding:40px;
  border-radius:25px;
  position:relative;
  overflow:hidden;
  box-shadow:0 20px 50px rgba(10,46,115,.25);
  border:1px solid rgba(212,175,55,.3);
}

.about-box::before{
  content:"";
  position:absolute;
  width:200px;
  height:200px;
  border-radius:50%;
  background:rgba(255,255,255,.05);
  top:-80px;
  right:-80px;
}

.company-title{
  display:flex;
  align-items:center;
  gap:12px;
  margin-bottom:20px;
}

.company-title svg{
  color:#d4af37;
}

.company-title h2{
  font-size:38px;
  font-weight:800;
  margin:0;
}

.about-box p{
  font-size:16px;
  line-height:1.8;
  margin-bottom:18px;
}

/* =========================
   FEATURES
========================= */

.features{
  display:flex;
  flex-direction:column;
  gap:14px;
  margin:25px 0;
}

.feature{
  display:flex;
  align-items:flex-start;
  gap:10px;
  background:rgba(255,255,255,.06);
  padding:12px;
  border-radius:12px;
  transition:.3s;
}

.feature:hover{
  background:rgba(255,255,255,.12);
}

.feature svg{
  color:#d4af37;
  flex-shrink:0;
}

.note{
  background:rgba(255,255,255,.08);
  border-left:4px solid #d4af37;
  padding:14px;
  border-radius:10px;
  margin-top:10px;
}

/* =========================
   BUTTON
========================= */

.about-btn{
  margin-top:20px;
  padding:14px 30px;
  border:none;
  border-radius:12px;
  background:linear-gradient(135deg,#d4af37,#f2cf63);
  color:#0A2E73;
  font-weight:700;
  cursor:pointer;
  transition:.35s;
}

.about-btn:hover{
  transform:translateY(-4px);
  box-shadow:0 12px 25px rgba(212,175,55,.35);
}

/* =========================
   TABLET
========================= */

@media (max-width:992px){

  .container{
    flex-direction:column;
    gap:45px;
  }

  .left{
    width:100%;
    min-height:500px;
  }

  .about-box{
    width:100%;
  }

  .section-heading h1{
    font-size:40px;
  }

  .company-title h2{
    font-size:32px;
  }

}

/* =========================
   MOBILE
========================= */

@media (max-width:768px){

  .about-section{
    padding:50px 15px;
  }

  .section-heading{
    margin-bottom:35px;
  }

  .section-heading h1{
    font-size:30px;
    letter-spacing:2px;
  }

  .section-heading h1::after{
    width:70px;
  }

  .container{
    flex-direction:column;
    gap:35px;
  }

  .left{
    position:static;
    min-height:auto;
    display:flex;
    flex-direction:column;
    gap:15px;
  }

  .img{
    position:relative;
    width:100%;
    height:220px;
    top:auto;
    left:auto;
    right:auto;
    bottom:auto;
    border-width:4px;
  }

  .img1,
  .img2,
  .img3{
    width:100%;
    height:220px;
  }

  .about-box{
    padding:25px 18px;
    border-radius:18px;
  }

  .company-title{
    flex-direction:column;
    text-align:center;
    gap:8px;
  }

  .company-title h2{
    font-size:26px;
  }

  .about-box p{
    font-size:15px;
    line-height:1.7;
    text-align:justify;
  }

  .feature{
    padding:12px;
    font-size:14px;
  }

  .note{
    font-size:14px;
    line-height:1.6;
  }

  .about-btn{
    width:100%;
    padding:14px;
    font-size:16px;
  }

}

/* =========================
   SMALL MOBILE
========================= */

@media (max-width:480px){

  .about-section{
    padding:40px 12px;
  }

  .section-heading h1{
    font-size:26px;
    letter-spacing:1px;
  }

  .img1,
  .img2,
  .img3{
    height:190px;
  }

  .company-title h2{
    font-size:22px;
  }

  .about-box{
    padding:20px 16px;
  }

  .about-box p{
    font-size:14px;
  }

  .feature{
    font-size:13px;
    gap:8px;
  }

  .about-btn{
    font-size:15px;
    padding:13px;
  }

}
`}</style>
    </section>
  );
};

export default AboutUsSection;